"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToUsers = exports.deleteUserRealTime = exports.editUserRealTime = exports.addUserRealTime = exports.editUser = exports.deleteUser = exports.addUser = exports.fetchUsersByOfficeId = exports.fetchStatics = exports.fetchUsersInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    allUsers: [],
    status: "idle",
    error: null,
    globalUsersData: {},
    USERS_ID_FULL_NAME: [],
    loaded: false,
    statics: { syria: 0, turkey: 0, caseNo: 0 },
};
// Fetch List and global users
exports.fetchUsersInBatches = (0, toolkit_1.createAsyncThunk)("users/fetchUsersInBatches", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, supabaseClient_1.supabase
                        .from("users_warehouses")
                        .select("*")];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    throw new Error(error.message);
                }
                return [2 /*return*/, data];
            case 2:
                err_1 = _b.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(err_1.message)];
            case 3: return [2 /*return*/];
        }
    });
}); });
// Thunk to fetch statics by id = 1
exports.fetchStatics = (0, toolkit_1.createAsyncThunk)("users/fetchStatics", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("statics").select("*")];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data[0]];
        }
    });
}); });
// Async thunk to fetch users by officeId
exports.fetchUsersByOfficeId = (0, toolkit_1.createAsyncThunk)("users/fetchUsersByOfficeId", function (officeId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("users_warehouses")
                    .select("*")
                    .eq("office", officeId)];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Add a new User record
exports.addUser = (0, toolkit_1.createAsyncThunk)("users/addUser", function (newUser, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError, authError, response, errorText, createdUser, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("users_warehouses")
                    .insert(newUser)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                return [4 /*yield*/, supabaseClient_1.supabase.functions.invoke("create-account", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                        },
                        body: JSON.stringify({
                            email: newUser.email,
                            password: "ida12345",
                        }),
                    })];
            case 2:
                authError = (_b.sent()).error;
                if (authError) {
                    console.error("Error creating user:", authError.message);
                }
                else {
                    console.log("User created successfully");
                }
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                _b.label = 3;
            case 3:
                _b.trys.push([3, 8, , 9]);
                return [4 /*yield*/, fetch("".concat(process.env.VITE_SUPABASE_URL, "/functions/v1/create-account"), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(process.env.SUPABASE_SERVICE_ROLE_KEY),
                        },
                        body: JSON.stringify({
                            email: newUser.email,
                            password: "ida12345",
                        }),
                    })];
            case 4:
                response = _b.sent();
                if (!!response.ok) return [3 /*break*/, 6];
                return [4 /*yield*/, response.text()];
            case 5:
                errorText = _b.sent();
                console.log({ errorText: errorText });
                console.error("Error creating user in Supabase Auth:", errorText);
                throw new Error(errorText);
            case 6: return [4 /*yield*/, response.json()];
            case 7:
                createdUser = _b.sent();
                console.log("User created in Supabase Auth successfully:", createdUser);
                return [3 /*break*/, 9];
            case 8:
                error_1 = _b.sent();
                console.log({ error: error_1 });
                console.error("Error calling Edge Function for user creation:", error_1.message);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a User record
exports.deleteUser = (0, toolkit_1.createAsyncThunk)("users/deleteUser", function (_uid, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase.rpc("delete_full_user_with_logs", { _uid: _uid })];
            case 1:
                error = (_a.sent()).error;
                // TODO: disable email
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, _uid];
        }
    });
}); });
// Edit a User record
exports.editUser = (0, toolkit_1.createAsyncThunk)("users/editUser", function (updatedUser, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("users_warehouses")
                    .update(updatedUser)
                    .eq("id", updatedUser.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-Time Actions
var addUserRealTime = function (newUser) { return ({
    type: "users_warehouses/addUserRealTime",
    payload: newUser,
}); };
exports.addUserRealTime = addUserRealTime;
var editUserRealTime = function (updatedUser) { return ({
    type: "users_warehouses/editUserRealTime",
    payload: updatedUser,
}); };
exports.editUserRealTime = editUserRealTime;
var deleteUserRealTime = function (id) { return ({
    type: "users_warehouses/deleteUserRealTime",
    payload: id,
}); };
exports.deleteUserRealTime = deleteUserRealTime;
// Slice definition
var usersSlice = (0, toolkit_1.createSlice)({
    name: "users_warehouses",
    initialState: initialState,
    reducers: {
        addUserRealTime: function (state, action) {
            var _a;
            var newUser = action.payload;
            var exists = state.data.some(function (user) { return user.id === newUser.id; });
            if (!exists) {
                state.data.push(newUser);
                state.globalUsersData[(_a = newUser.id) !== null && _a !== void 0 ? _a : ""] = newUser;
            }
            state.error = null;
        },
        editUserRealTime: function (state, action) {
            var _a;
            var updatedUser = action.payload;
            state.globalUsersData[(_a = updatedUser.id) !== null && _a !== void 0 ? _a : ""] = updatedUser;
            var index = state.data.findIndex(function (user) { return user.id === updatedUser.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(updatedUser);
                if (isDifferent) {
                    state.data[index] = updatedUser;
                }
            }
            var indexForAllUsers = state.allUsers.findIndex(function (user) { return user.id === updatedUser.id; });
            if (indexForAllUsers !== -1) {
                var isDifferent = JSON.stringify(state.allUsers[indexForAllUsers]) !==
                    JSON.stringify(updatedUser);
                if (isDifferent) {
                    state.allUsers[indexForAllUsers] = updatedUser;
                }
            }
            state.error = null;
        },
        deleteUserRealTime: function (state, action) {
            var exists = state.data.some(function (user) { return user.id === action.payload; });
            if (exists) {
                state.data = state.data.filter(function (user) { return user.id !== action.payload; });
            }
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // Handle fetchUsersByOfficeId
            .addCase(exports.fetchUsersByOfficeId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchUsersByOfficeId.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.data = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchUsersByOfficeId.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to add user.";
        })
            // Handle fetchStatics
            .addCase(exports.fetchStatics.pending, function (state) { })
            .addCase(exports.fetchStatics.fulfilled, function (state, action) {
            state.statics = action.payload; // Update the statics in the state
            state.error = null;
        })
            .addCase(exports.fetchStatics.rejected, function (state, action) {
            state.error = action.payload || "Failed to fetch statics.";
        })
            // Handle addUser
            .addCase(exports.addUser.pending, function (state) { })
            .addCase(exports.addUser.fulfilled, function (state, action) {
            state.error = null;
        })
            .addCase(exports.addUser.rejected, function (state, action) {
            state.error = action.payload || "Failed to add user.";
        })
            // Handle deleteUser
            .addCase(exports.deleteUser.pending, function (state) { })
            .addCase(exports.deleteUser.fulfilled, function (state, action) {
            state.data = state.data.filter(function (user) { return user.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteUser.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete user.";
        })
            // Handle editUser
            .addCase(exports.editUser.pending, function (state) { })
            .addCase(exports.editUser.fulfilled, function (state, action) {
            state.error = null;
        })
            .addCase(exports.editUser.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to edit user.";
        })
            // Handle fetchUsersInBatches
            .addCase(exports.fetchUsersInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            action.payload.forEach(function (user) {
                state.globalUsersData[user.id] = user;
            });
            state.allUsers = action.payload;
        })
            .addCase(exports.fetchUsersInBatches.rejected, function (state, action) {
            console.error("Error fetching users:", action.payload);
        });
    },
});
// Real-time subscription function
var subscribeToUsers = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:users_warehouses")
        .on("postgres_changes", { event: "*", schema: "public", table: "users_warehouses" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addUserRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editUserRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteUserRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToUsers = subscribeToUsers;
exports.default = usersSlice.reducer;
